/**
 * URL Codes that are returned from backend as URL params
 *
 * @type {Readonly<{UNAUTHORIZED_USER: string}>}
 */
export const URL_CODES = Object.freeze({
    UNAUTHORIZED_USER : "401",
});